import React, { useContext, useEffect, useState } from "react";
import MobileProfileTopNavigation from "../../Pages/MobileProfileLayout/MobileProfileTopNavigation";
import { getAppointmentHistory, getUserApi } from "../../apis";
import ConsultationCard from "../../components/ConsultationCard/ConsultationCard";
import ConsultationViewRequest from "../../components/ConsultationCard/ConsultationViewRequest";
import useDeviceType from "../../utils/useDeviceType";
import Placeholder from "../../components/placeholder";
import NoConsultation from '../../lottiefiles/no_consultation.json';
export default function AppointmentHistorySection({ handleviewreqdesktop }) {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const [appointmentHistoryData, setAppointmentHistoryData] = useState(null);
    const [profileData, setprofileData] = useState(null);
    const [filterHistory, setFilterHistory] = useState('yearly');
    const [ViewRequestBlock, setViewRequestBlock] = useState(false);
    const [currentrequest, setcurrentrequest] = useState(null);
    const toGetAppointmentHistory = async (id) => {
        try {
            const res = await getAppointmentHistory(id);
            console.log(res);
            if (res.status === 200) {
                console.log(res.data.AppointmentHistory);
                setAppointmentHistoryData(res.data?.AppointmentHistory);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const fetchHospital = async (id) => {
        try {
            const res = await getUserApi(id);
            if (res.status === 200) {
                setprofileData(res?.data?.Profile);
                toGetAppointmentHistory(res?.data?.Profile?.hospitalProfile?._id);
            }
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchHospital(localStorage.getItem('userId'));
    }, []);

    const handleHistoryFilter = (event) => {
        const value = event.target.value;
        toGetAppointmentHistory(
            `${profileData.hospitalProfile?._id}&filter=${value}`
        );
        setFilterHistory(value);
    };
    let appointHistoryBlock;

    appointHistoryBlock = appointmentHistoryData?.map((data, key) => (
        // No Consultations found.
        <div key={key}>
            <ConsultationCard
                fillBtnTitle={'View Detail'}
                data={data}
                ViewRequest={() => {
                    if (deviceType == 'Mobile' || deviceType == 'Tablet') {
                        handelViewRequestBlockMob(data, profileData)
                    }
                    else {
                        handleviewreqdesktop(data, profileData)
                    }

                }}
                fillBtnfun={() => {
                    if (deviceType == 'Mobile' || deviceType == 'Tablet') {
                        handelViewRequestBlockMob(data, profileData)
                    }
                    else {
                        handleviewreqdesktop(data, profileData)
                    }
                }}
                showDeleteBtn={false}
            />
        </div>
    ))
    function handelViewRequestBlockMob(data, proData) {
        setViewRequestBlock(!ViewRequestBlock);
        setcurrentrequest(data?._id);
        setprofileData(profileData);
    }
    const deviceType = useDeviceType();
    return (
        <>
            <div className='pt-[20%] md:pt-[10%] px-6 bg-white h-[100vh] w-[100vw] lg:pt-[0px] lg:px-0 lg:h-[auto] lg:w-[auto]'>
                <div className="flex items-center flex-wrap gap-4 my-5 lg:hidden">
                    <MobileProfileTopNavigation pageTitle={'Appointment History'} />
                    <select
                        name="report"
                        className=" bg-accent text-white px-4 py-2 rounded-md min-w-[184px] capitalize w-full lg:hidden md:w-[auto] md:ml-[auto]"
                        onChange={handleHistoryFilter}
                        value={filterHistory}
                    >
                        <option
                            className="text-coalBlack bg-white baseText  whitespace-nowrap"
                            value={'weekly'}
                        >
                            {' '}
                            Weekly report
                        </option>
                        <option
                            className="text-coalBlack bg-white baseText  whitespace-nowrap"
                            value={'monthly'}
                        >
                            Monthly report
                        </option>
                        <option
                            className="text-coalBlack bg-white baseText  whitespace-nowrap"
                            value={'yearly'}
                        >
                            Yearly report
                        </option>
                    </select>
                </div>
                <div className="items-center flex-wrap gap-4 mb-7 hidden lg:flex">
                    <select
                        name="report"
                        className=" bg-accent text-white px-4 py-2 rounded-md min-w-[184px] capitalize w-full lg:w-auto lg:ms-auto"
                        onChange={handleHistoryFilter}
                        value={filterHistory}
                    >
                        <option
                            className="text-coalBlack bg-white baseText  whitespace-nowrap"
                            value={'weekly'}
                        >
                            {' '}
                            weekly report
                        </option>
                        <option
                            className="text-coalBlack bg-white baseText  whitespace-nowrap"
                            value={'monthly'}
                        >
                            monthly report
                        </option>
                        <option
                            className="text-coalBlack bg-white baseText  whitespace-nowrap"
                            value={'yearly'}
                        >
                            yearly report
                        </option>
                    </select>
                </div>
                
                    {appointmentHistoryData?.length != 0 ? (
                        <>
                        <div className="grid grid-cols-1 md:grid-cols-2  gap-4 pb-[25%]">
                         {appointHistoryBlock}
                        </div>
                           
                        </>
                    ) : (
                         <Placeholder
        title='No Consultations found.'
        animationData={NoConsultation}
        height={200}
        message='No consultation requests were found at the moment.'
        />
                    )}
             
            </div>
            {ViewRequestBlock && (
                <ConsultationViewRequest
                    closeFunction={() => {
                        if (deviceType == 'Mobile' || deviceType == 'Tablet') {
                            handelViewRequestBlockMob()
                        }
                        else {
                            handleviewreqdesktop()
                        }
                    }}
                    currentdata={currentrequest}
                    profileData={profileData}
                    navigatedFromNotification={false}
                />
            )}
        </>
    )
}